<template>
  <div class="mb-4">
    <v-card elevation="0" style="border: 1px solid #eee; border-radius: 10px; position: relative">
      <v-card-title style="background: #eee" class="font-weight-bold">
        {{ $t('Search') }}
      </v-card-title>
      <v-card-text>
        <v-layout wrap class="form-control">
          <v-flex xs12 sm4 px-2>
            <div class="caption">Intent name</div>
            <!-- <input v-model="filterInput.intent" type="text" placeholder="Intent name" /> -->
            <multiselect
              v-model="filterInput.intent"
              :options="intentOptions"
              :searchable="true"
              select-label
              selected-label
              deselect-label
              placeholder="Intent name"
            ></multiselect>
          </v-flex>
          <v-flex xs6 sm4 px-2>
            <div class="caption">Start date</div>
            <DatepickerCustomDialog
              v-model="filterInput.start_date"
              :allowed-dates="allowedDates"
              @change="handleChangeStartDate"
            >
              <input
                type="text"
                :value="handleGetDateFormatted(filterInput.start_date)"
                placeholder="Start date"
                readonly
              />
            </DatepickerCustomDialog>
          </v-flex>
          <v-flex xs6 sm4 px-2>
            <div class="caption">End date</div>
            <DatepickerCustomDialog
              v-model="filterInput.end_date"
              :allowed-dates="allowedDates"
              @change="handleChangeEndDate"
            >
              <input
                type="text"
                :value="handleGetDateFormatted(filterInput.end_date)"
                placeholder="End date"
                readonly
              />
            </DatepickerCustomDialog>
          </v-flex>
          <v-flex xs12 class="text-xs-right">
            <v-btn outline color="grey" @click="handleClearSearch">{{ $t('Clear Search') }}</v-btn>
            <v-btn depressed color="primary" @click="handleSearch">
              <em class="fas fa-search mr-1" />
              {{ $t('Search') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { DATETIME } from '@/constants/datetime.js'
import DatepickerCustomDialog from '@/components/elements/DatepickerCustomDialog.vue'
import Multiselect from 'vue-multiselect'

export default {
  components: {
    DatepickerCustomDialog,
    Multiselect
  },
  props: {
    filters: {
      type: Object,
      default: () => {}
    },
    intentRawData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      filterInput: {
        intent: '',
        start_date: '',
        end_date: ''
      }
    }
  },
  computed: {
    intentOptions() {
      return this.intentRawData ? this.intentRawData.map((item) => item.intent) : []
    }
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        this.handleInit()
      }
    }
  },
  mounted() {
    this.handleInit()
  },
  methods: {
    handleInit() {
      if (this.filters) {
        this.filterInput.intent = this.filters.intent
        this.filterInput.start_date = this.filters.start_date
        this.filterInput.end_date = this.filters.end_date
      }
    },
    handleSearch() {
      this.$emit('onSearch', this.filterInput)
    },
    handleClearSearch() {
      this.$emit('onClearSearch')
    },
    handleGetDateFormatted(value) {
      return value ? dayjs(value).format(DATETIME.DATE_FORMAT_DISPLAY) : ''
    },
    allowedDates(val) {
      return dayjs().diff(val, 'hour', true) > 0
    },
    handleChangeStartDate(value) {
      if (dayjs(this.filterInput.end_date).isBefore(value)) {
        this.filterInput.end_date = value
      }
      this.filterInput.start_date = value
    },
    handleChangeEndDate(value) {
      if (dayjs(value).isBefore(this.filterInput.start_date)) {
        this.filterInput.start_date = value
      }
      this.filterInput.end_date = value
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/customize/generali/SatisfactionSurveyReport/AdvanceSearch.vue